var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 4.80001C7.57556 4.80001 7.16859 4.63144 6.86853 4.33138C6.56847 4.03132 6.3999 3.62435 6.3999 3.20001C6.3999 2.77566 6.56847 2.36869 6.86853 2.06864C7.16859 1.76858 7.57556 1.60001 7.9999 1.60001C8.42425 1.60001 8.83121 1.76858 9.13127 2.06864C9.43133 2.36869 9.5999 2.77566 9.5999 3.20001C9.5999 3.62435 9.43133 4.03132 9.13127 4.33138C8.83121 4.63144 8.42425 4.80001 7.9999 4.80001ZM7.9999 9.60001C7.57556 9.60001 7.16859 9.43144 6.86853 9.13138C6.56847 8.83132 6.3999 8.42435 6.3999 8.00001C6.3999 7.57566 6.56847 7.16869 6.86853 6.86864C7.16859 6.56858 7.57556 6.40001 7.9999 6.40001C8.42425 6.40001 8.83121 6.56858 9.13127 6.86864C9.43133 7.16869 9.5999 7.57566 9.5999 8.00001C9.5999 8.42435 9.43133 8.83132 9.13127 9.13138C8.83121 9.43144 8.42425 9.60001 7.9999 9.60001ZM7.9999 14.4C7.57556 14.4 7.16859 14.2314 6.86853 13.9314C6.56847 13.6313 6.3999 13.2244 6.3999 12.8C6.3999 12.3757 6.56847 11.9687 6.86853 11.6686C7.16859 11.3686 7.57556 11.2 7.9999 11.2C8.42425 11.2 8.83121 11.3686 9.13127 11.6686C9.43133 11.9687 9.5999 12.3757 9.5999 12.8C9.5999 13.2244 9.43133 13.6313 9.13127 13.9314C8.83121 14.2314 8.42425 14.4 7.9999 14.4Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/DotsVertical.88fbdccb402f99a04e4c2f9a7fd61e8b.svg";
export { ForwardRef as ReactComponent };